import { oz } from '@weft/utils';
import { DynamicInvoicePageCustomerSchema } from './dynamic-invoice-page-data-contact-schema';
import { DynamicInvoicePageInvoiceSchema } from './dynamic-invoice-page-data-invoice-schema';
import { DynamicInvoiceMeasurementChartDataSchema } from './dynamic-invoice-page-measurement-chart-schema';

export const DynamicInvoiceDataSchema = oz.object({
  invoice: DynamicInvoicePageInvoiceSchema,
  customer: DynamicInvoicePageCustomerSchema,
  measurementChartData: DynamicInvoiceMeasurementChartDataSchema,
}).openapi('DynamicInvoiceData');

export type DynamicInvoiceData = oz.infer<typeof DynamicInvoiceDataSchema>;